<img [attr.src]="assetUrl()" [attr.alt]="alt()" [attr.height]="height()" [attr.width]="width()" />
